import Vue from "vue";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/src/sweetalert2.scss";
Vue.use(VueSweetalert2);

export default new VueSweetalert2();
